import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, createElementBlock as _createElementBlock, withDirectives as _withDirectives, withCtx as _withCtx, Fragment as _Fragment } from "vue";
const _hoisted_1 = {
  class: "flex px-6 p-3 lg:px-0 lg:py-2 align-items-center text-indigo-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple"
};
const _hoisted_2 = {
  class: "block"
};
const _hoisted_3 = {
  class: "text-indigo-50 font-medium"
};
const _hoisted_4 = {
  class: "list-none py-3 px-6 m-0 lg:px-0 lg:py-0 border-round shadow-0 lg:border-1 border-50 lg:shadow-2 lg:absolute surface-overlay hidden origin-top w-full lg:w-10rem cursor-pointer z-5"
};
const _hoisted_5 = {
  key: 0
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Avatar = _resolveComponent("Avatar");
  const _component_router_link = _resolveComponent("router-link");
  const _directive_styleclass = _resolveDirective("styleclass");
  const _directive_ripple = _resolveDirective("ripple");
  return _openBlock(), _createElementBlock(_Fragment, null, [_withDirectives((_openBlock(), _createElementBlock("a", _hoisted_1, [$data.store?.currentUser?.avatar ? (_openBlock(), _createBlock(_component_Avatar, {
    key: 0,
    size: "medium",
    shape: "circle",
    class: "mr-2",
    image: $data.store?.currentUser.avatar
  }, null, 8, ["image"])) : _createCommentVNode("", true), !$data.store?.currentUser?.avatar ? (_openBlock(), _createBlock(_component_Avatar, {
    key: 1,
    size: "medium",
    shape: "circle",
    class: "mr-2",
    style: {
      "color": "#333"
    },
    label: $data.store?.currentUser?.first_name.slice(0, 1) + $data.store?.currentUser?.last_name.slice(0, 1)
  }, null, 8, ["label"])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, _toDisplayString($data.store?.currentUser?.first_name) + " " + _toDisplayString($data.store?.currentUser?.last_name), 1)]), _cache[0] || (_cache[0] = _createElementVNode("i", {
    class: "pi pi-angle-down ml-auto text-white lg:ml-2"
  }, null, -1))])), [[_directive_styleclass, {
    selector: '@next',
    enterFromClass: 'hidden',
    enterActiveClass: 'scalein',
    leaveToClass: 'hidden',
    leaveActiveClass: 'fadeout',
    hideOnOutsideClick: true
  }]]), _createElementVNode("ul", _hoisted_4, [$data.store?.currentUser?.user_type == 'staff' && $options.canUseLeave() ? (_openBlock(), _createElementBlock("li", _hoisted_5, [_withDirectives((_openBlock(), _createBlock(_component_router_link, {
    to: "/management/my-profile",
    class: "flex p-3 align-items-center text-600 hover:text-900 no-underline hover:surface-100 transition-colors transition-duration-150 p-ripple"
  }, {
    default: _withCtx(() => [...(_cache[1] || (_cache[1] = [_createElementVNode("i", {
      class: "pi pi-user mr-2"
    }, null, -1), _createElementVNode("span", {
      class: "font-medium"
    }, "My profile", -1)]))]),
    _: 1
  })), [[_directive_ripple]])])) : _createCommentVNode("", true), _createElementVNode("li", null, [_withDirectives((_openBlock(), _createBlock(_component_router_link, {
    to: "/logout",
    class: "flex p-3 align-items-center text-600 hover:text-900 no-underline hover:surface-100 transition-colors transition-duration-150 p-ripple"
  }, {
    default: _withCtx(() => [...(_cache[2] || (_cache[2] = [_createElementVNode("i", {
      class: "pi pi-sign-out mr-2"
    }, null, -1), _createElementVNode("span", {
      class: "font-medium"
    }, "Sign out", -1)]))]),
    _: 1
  })), [[_directive_ripple]])])])], 64);
}